/**
 * Factory functions to build actions communicating with GEO and the application
 * This is the main way to send action to GEO (app and map).
 * ## Actions concepts
 * Action are payload of informations that send datas from your application to
 * GEO. They can be simple object, for example :
 *
 * ```javascript
 * {
 *   type:'ZOOM_IN",
 *   payload:{}
 *
 * }
 * ```
 *
 * Actions creators are function that create those object,statically typed. so
 * the last example can be also call by
 * ```
 * let action=  zoomInCreator() ;
 * ```
 *
 * Those actions are then send to the application :
 * ```
 * geoApp.store.dispatch(action)
 * //it's exactly the same as geoApp.map().zoomIn()
 * ```
 *
 * ## Async Actions
 *  Calls are asynchronous, since many of them may require a roundtrip to the
 * server. GeoApi let one create async actions, by using specific async creator(
 * with a P suffix on the method name ,f or example zoomInCreatorP). The promise
 * is resolved/reject when the action have been dispatch and fulfilled. Then ,
 * the action creator take parameters as  first argument, and store dispatcher
 * as second
 *
 *
 *
 *  For example, in  a plain js  web page:
 * ```
 * geoApi.zoomInCreatorP({},geoApp.store.dispatch).then(response=>console.log(response));
 * ```
 *
 * or using modules:
 * ```
 *  zoomInCreatorP({},geoApp.store.dispatch).then(response=>console.log(response));
 * ```
 * @module geo/actions/creators
 * @preferred
 *
 */
export {setEntriesVisibilityCreator} from './entry.visibility.creator';
export * from './application.creators'
export * from './base.layer.visibility.creator'
export * from './component.state.creator'
export * from './data.refresh.event.creator'
export * from './entry.visibility.creator'
export * from './filter.history.creator'
export * from './functionality.creator'
export * from './global.parameter.value.creator'
export * from './init.application.creator'
export * from './localisation.creators'
export * from './map.eventsCreator'
export * from './markers.creator'
export * from './proxy.creators'
export * from './selection.creator'
export * from './service.get.image.map.creator'
export * from './services.creator'